import { useEffect, useRef, useState } from 'react';

import { useKey } from '../../useKey';
import Loader from '../loader/Loader';
import StarRating from '../../StarRating';
import Btn from '../btn/Btn';

import './movieDetails.scss';
import PictureFrame from '../pictureFrame/PictureFrame';
import Plug from '../plug/Plug';

function MovieDetails({ selectedId, onCloseMovie, onAddWatched, watched }) {
  const [movie, setMovie] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [userRating, setUserRating] = useState('');

  const countRef = useRef(0);

  useEffect(
    function () {
      if (userRating) countRef.current++;
    },
    [userRating]
  );

  const KEY = '1a659df1';
  const isWatched = watched.map((item) => item.imdbID).includes(selectedId);
  const waychedUserRating = watched.find(
    (movie) => movie.imdbID === selectedId
  )?.userRating;

  const {
    Title: title,
    Year: year,
    Poster: poster,
    Runtime: runtime,
    imdbRating,
    Plot: plot,
    Released: released,
    Actors: actors,
    Director: director,
    Genre: genre,
  } = movie;

  function handleAdd() {
    const newWatchedMovie = {
      imdbID: selectedId,
      title,
      year,
      poster,
      imdbRating: Number(imdbRating),
      runtime: Number(runtime.split(' ').at(0)),
      poster,
      userRating,
      countRatingDecisions: countRef.current,
    };

    onAddWatched(newWatchedMovie);
    onCloseMovie();
  }

  useEffect(
    function () {
      async function getMovieDetails() {
        setIsLoading(true);
        const res = await fetch(
          `https://www.omdbapi.com/?apikey=${KEY}&i=${selectedId}`
        );
        const data = await res.json();
        setMovie(data);
        setIsLoading(false);
      }
      getMovieDetails();
    },
    [selectedId]
  );

  useEffect(
    function () {
      if (!title) return;
      document.title = `Movie | ${title}`;
      return function () {
        document.title = 'usePopcorn';
      };
    },
    [title]
  );

  useKey('Escape', onCloseMovie);

  return (
    <div className='details'>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <header>
            <div className='details__header'>
              <Btn type='back' onClick={onCloseMovie}>
                &lt;
              </Btn>
              <div className='details__img'>
                {poster !== 'N/A' ? (
                  <PictureFrame>
                    <img src={poster} alt={`${title} poster`} />
                  </PictureFrame>
                ) : (
                  <Plug>{`${poster}`}</Plug>
                )}
              </div>
              <div className='details-overview'>
                <h2>{title}</h2>
                <p>
                  <span>{released}</span> <span>&bull; {runtime}</span>
                </p>
                <p>{genre}</p>
                <p>
                  <span>⭐</span>
                  {imdbRating} IMDb rating
                </p>
              </div>
            </div>
          </header>
          <section>
            <div className='rating'>
              {!isWatched ? (
                <>
                  <StarRating
                    maxRating={7}
                    size={24}
                    onSetRating={setUserRating}
                  />
                  {userRating > 0 && (
                    <Btn type='add' onClick={handleAdd}>
                      + Add to list
                    </Btn>
                  )}
                </>
              ) : (
                <p>
                  You rated with movie {waychedUserRating} <span>⭐</span>
                </p>
              )}
            </div>
            <p>
              <em>{plot}</em>
            </p>
            <p>Starring {actors}</p>
            <p>Directed by {director}</p>
          </section>
        </>
      )}
    </div>
  );
}

export default MovieDetails;
